import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ClassificationModel } from '../models/ClassificationModel';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class ClassificationService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
  public getClassificationLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<ClassificationModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Classification/ClassificationLookupTop', options);
  }


}
